import Reveal from "@/components/Reveal";

const Transition = () => {
  return (
    <section
      data-testid="transition-section"
      className="dark-section relative flex items-center"
      style={{ minHeight: "90vh" }}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-32 md:py-48 w-full">
        <Reveal className="max-w-3xl" slow>
          <p className="hairline mb-10 opacity-70" data-testid="transition-label">
            II. An offering
          </p>
          <p
            className="font-serif italic text-3xl md:text-5xl leading-[1.15] text-[color:var(--bone)]"
            data-testid="transition-statement-1"
          >
            A small number of works have been released from Chapter II.
          </p>
          <p
            className="font-serif italic text-2xl md:text-3xl leading-[1.25] text-[color:var(--bone)] opacity-80 mt-10"
            data-testid="transition-statement-2"
          >
            Available for those who wish to hold a part of it.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Transition;
